import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { FamilyStore } from "./FamilyStore";

export class AddParentStore {
  store: FamilyStore;
  showDlg = false;
  loading = false;
  saving = false;
  isNew = false;
  searchUser: any = null;

  constructor(store: FamilyStore) {
    makeAutoObservable(this, {});
    this.store = store;
  }

  get children() {
    return this.store.family?.parents?.reduce((pre, it) => {
      for (let c of it.user.children) {
        if (!pre.find((x) => x.childId === c.childId)) {
          pre = [...pre, c];
        }
      }
      return pre;
    }, []);
  }

  @action show() {
    this.isNew = false;
    this.showDlg = true;
  }
  @action close() {
    this.showDlg = false;
  }

  @action findUserByEmail(email) {
    return Api.user.findByEmail(email).then((res) => {
      const users = res.data.findUserByEmail;
      runInAction(() => {
        this.searchUser = users?.[0] || null;
      });
      return users;
    });
  }

  @action save(values) {
    const { childIds, firstName, lastName, mobile, email } = values;
    this.saving = true;

    if (this.isNew) {
      return Api.family
        .familyAddNewParent({
          childIds,
          firstName,
          lastName,
          email,
          mobile: mobile?.replace(/[ \-()]/g, ""),
        })
        .finally(() => (this.saving = false));
    }

    if (!this.searchUser) {
    }
    return Api.family.familyAddExistingParent(childIds, this.searchUser?.id).finally(() => (this.saving = false));
  }
}
